import { matchPath } from "react-router-dom";

import { Link } from "common/types/routing";

export function linkToTeacherDashboard() {
  return "/teacher";
}

export function isInTeacherPlatform(pathname: Link) {
  const stringpath =
    // @ts-ignore
    typeof pathname === "string" ? pathname : pathname.pathname;

  if (!stringpath) {
    return false;
  }

  return matchPath(stringpath, {
    path: linkToTeacherDashboard(),
    exact: false
  });
}
